const taxes: {id: number, name: string }[] = [
  {id: 0.19, name: "19 %"},
  {id: 0.16, name: "16 %"},
  {id: 0.07, name: "7 %"},
  {id: 0.05, name: "5 %"},
  {id: 0.0, name: "0 %"}
]

export default taxes